import { render, staticRenderFns } from "./tabulation.vue?vue&type=template&id=dd3d864a&scoped=true&"
import script from "./tabulation.vue?vue&type=script&lang=js&"
export * from "./tabulation.vue?vue&type=script&lang=js&"
import style0 from "./tabulation.vue?vue&type=style&index=0&lang=css&"
import style1 from "./tabulation.vue?vue&type=style&index=1&id=dd3d864a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3d864a",
  null
  
)

export default component.exports